import React, { Component } from 'react';
import { graphql, createFragmentContainer } from 'react-relay';
import { TableRow, TableRowColumn } from 'material-ui/Table';
import Grid from '../grid/Grid';
import enhancer from '../enhancer';

class Rates extends Component {
  renderRow = ({ node }) => (
    <TableRow key={node.id}>
      <TableRowColumn>{node.name}</TableRowColumn>
      <TableRowColumn>{node.code}</TableRowColumn>
    </TableRow>
  );

  render() {
    const { master } = this.props;

    return (
      <div>
        <Grid
          headers={['Name', 'Code']}
          rows={master.allGrades.edges}
          renderRow={this.renderRow}
        />
      </div>
    );
  }
}

// TODO repalce with allRates when it is available
const query = graphql`
  query RatesAdminQuery {
    master {
      ...Rates_master
    }
  }
`;

export default enhancer(Rates, {
  relay: {
    query,
    create: () =>
      createFragmentContainer(Rates, {
        master: graphql`
          fragment Rates_master on Master {
            allGrades(first: 10) {
              edges {
                node {
                  id
                  name
                  code
                }
              }
            }
          }
        `,
      }),
  },
});



// WEBPACK FOOTER //
// ./src/components/master/Rates.js